import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

type UseAddAnnotationCommentMutationVariables = {
  annotationId: string;
  type: VirtualTourAnnotationCommentType;
  message?: string;
  cleanMessage?: string;
  mentions?: Array<string>;
  version?: number;
  metadata?: {
    attachments?: Omit<VirtualTourAnnotationCommentAttachment, 'url'>[];
  };
};

export const useAddAnnotationCommentMutation = () => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();
  const result = useMutation({
    mutationFn: async (payload: UseAddAnnotationCommentMutationVariables) => {
      const { data } = await authApi.post(
        `/virtual-tour/annotation/comment`,
        payload
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["virtual-tour-annotations"],
      });
    },
  });

  return result;
};
